module.exports = __webpack_public_path__ + "img/ring_skip_0_0_null@2x.c4d636c4.png";